import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { DataService } from '../../services/data.service';
import { BookShipmentRequest } from './book-shipment';
import { ReQueryFormData } from 'src/app/shared/common-components/common-structure';


@Injectable({
    providedIn: 'root'
})

export class HhgOnlineBookShipmentService extends DataService {

    private baseURI = '/tmssserver/api/shipmentsinfo/';
    private onTimeBaseURI = this.apiUri + '/frtontimeshipments/';
    private tspRatingURI = this.apiUri + '/frttsprating/';
    private bookShipmentURI = this.apiUri + '/bookShipments/';

    shipmentsInit: any;
    private shipmentsObserver$ = new BehaviorSubject<any>(null);
    frtQueryData = new BehaviorSubject<ReQueryFormData>(null);

    constructor(http: HttpClient) {
        super(http);
    }

    /**
     * @description saves the online hhg shipment
     * @param shipmentInfo: current online hhg shipment info object
     */
    saveShipment(shipmentRequest: BookShipmentRequest) {
        return this.http.post(this.baseURI + 'createshipments', shipmentRequest);
    }

    saveTrackingNumber(bookshipmentid: number, trackingNumber: string) {
        const shipmentInfo = { bookshipmentid, trackingNumber };
        return this.http.post(this.bookShipmentURI + 'saveTrackingNum', shipmentInfo);
    }

    /**
     * @description duplicate the online Freight Shipment
     * @param shipmentinfo: current online frt shipment info object
     */
    duplicateShipment(shipmentRequest: BookShipmentRequest) {
        return this.http.post(this.baseURI + 'duplicateshipments', shipmentRequest);
    }

    /**
     * @description retrieves hhg shipment
     * @param bookshipmentid: book shipment id of the shipment
     */
    getShipmentInfoByBookShipmentId(bookshipmentid: number): Observable<any> {
        return this.http.get(this.baseURI + bookshipmentid + '/bookshipmentid');
    }

    copyFreightAddressDetails(oldShipmentInfoId: number, newShipmentInfoId: number): Observable<any> {
        console.log('old shipment id', oldShipmentInfoId, 'new shipemnt id ', newShipmentInfoId);
        return this.http.get(this.baseURI + 'copy/' + oldShipmentInfoId + '/oldShipmentInfoId/' + newShipmentInfoId + '/newShipmentInfoId');
    }

    /**
   * @description fetches the calculated FRT results.
   */
    getFrtCalculatedResults(payload): Observable<any> {
        return this.http.post(this.baseURI + 'frtshoprates', payload);
    }

    // using this to avoid local storage
    setShipmentsObservable(shipmentInfo: any) {
        this.shipmentsObserver$.next(shipmentInfo);
    }

    // using this to avoid local storage
    getShipmentsObservable() {
        return this.shipmentsObserver$.asObservable();
    }

  /**
   * @description fetches the on time FRT results.
   */
  getFrtOnTimeResults(year): Observable<any> {
    return this.http.get(this.onTimeBaseURI + year);
  }

   /**
   * @description FRT TSP rating.
   */
   getFrtTspRating(year): Observable<any> {
    return this.http.get(this.tspRatingURI + year);
  }

}
